import { render, staticRenderFns } from "./CtcCreateView.vue?vue&type=template&id=5318d0c1&scoped=true&"
import script from "./CtcCreateView.vue?vue&type=script&lang=js&"
export * from "./CtcCreateView.vue?vue&type=script&lang=js&"
import style0 from "./CtcCreateView.vue?vue&type=style&index=0&id=5318d0c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318d0c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
installComponents(component, {VCard,VIcon,VStepperContent})
